/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Account_SubtitleInputs */

const en_common_account_subtitle = /** @type {(inputs: Common_Account_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Access your account details`)
};

const es_common_account_subtitle = /** @type {(inputs: Common_Account_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detalles de tu cuenta`)
};

/**
* | output |
* | --- |
* | "Access your account details" |
*
* @param {Common_Account_SubtitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const common_account_subtitle = /** @type {((inputs?: Common_Account_SubtitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Account_SubtitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_common_account_subtitle(inputs)
	return en_common_account_subtitle(inputs)
});